export const howItWorksSteps = [
  {
    title: 'A patented probe sits in a sealed chamber',
    body: 'The chamber holds pool acid. It is closed, external to your water, and the acid itself never enters the pool.',
  },
  {
    title: 'Electrolysis releases charged hydrogen',
    body: 'The probe pulls negatively charged hydrogen bubbles out of the solution \u2014 safe, and powerful.',
  },
  {
    title: 'Your existing pump carries them through',
    body: 'The bubbles travel through your pump and filter and disperse into the full body of water, killing algae and bacteria.',
  },
  {
    title: 'Water settles at a perfect 7.2\u20137.6 pH',
    body: 'No irritation, no chemical smell, no toxins. Clarity that holds itself, month after month.',
  },
]
